import React from 'react'
import { Button, Card, Modal, OverlayTrigger, Spinner, Tooltip } from 'react-bootstrap'
import './callDetails.scss'
import TextArea from '../../jsx/components/fields/textArea';
import { callDetails } from "../../service/api/callHistory/callDetails";
import { resendVideoLink } from "../../service/api/callHistory/resendVideoLink";
import { deleteCallHistory } from "../../service/api/callHistory/deleteSingleDetails";
import { callNote } from "../../service/api/callHistory/callNote";
import { callNoteDetails } from "../../service/api/callHistory/callNoteDetails";
import InternationalPhoneFormatFun from "../../ui/InternationalPhoneFormatFun";
import sendReportOfDiagonsisApi from "../../service/api/documentGenerator/createReport";

import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useRef } from 'react';
import { useState } from 'react';
import { useEffect } from 'react';
import ReadOnlyRating from '../../jsx/components/rating/ReadOnlyRating';
import PrimaryButton from '../../jsx/components/button/primaryButton';
import InputField from '../../jsx/components/fields/inputField';
import WhiteGreenButton from '../../jsx/components/button/whiteGreenButton';
import { hintAddComments, hintEstimatedCostRepair, hintRepairSuggestion, hintToolsSupplies, lblDiscussion, lblEstimatedCostRepair, lblRepairSuggestion, lblToolsSupplies, txtCallDetails, txtCreatedOn, txtEmail, txtMessage, txtName, txtPhoneNumber, txtServiceID } from '../../dataBaseFile/label';
import { btnDiagnosisReport, btnJoinVideo, btnSubmit } from '../../dataBaseFile/alert';
import PurchaseList from '../../jsx/components/purchaseList/purchaseList';

const CallDetailsPage = () => {
    // All tooltips are here
    const tooltipAttachment = (
        <Tooltip id="tooltip" >
            <strong >Attachments</strong>
        </Tooltip>
    );

    const tooltipDownload = (
        <Tooltip id="tooltip" >
            <strong >Download Report</strong>
        </Tooltip>
    );
    const tooltipShowNotes = (
        <Tooltip id="tooltip" >
            <strong >Show call notes</strong>
        </Tooltip>
    );
    const tooltipHideNotes = (
        <Tooltip id="tooltip" >
            <strong >Hide call notes</strong>
        </Tooltip>
    );

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const hiddenFileInput = useRef(0);
    const { role, permissionArr } = useSelector((state) => state.user);

    const permissionArray = permissionArr[0] || []

    const [elements, setElements] = useState([]);
    const [callDetailsObj, setCallDetailsObj] = useState({});
    const [receiverData, setReceiverData] = useState([]);
    const [joinLoading, setJoinLoading] = useState(false);

    const [resendLoading, setResendLoading] = useState(false);
    const [showSuccess, setShowSuccess] = useState(false);
    const [showError, setShowError] = useState(false);
    const [time, setTime] = useState(0);
    const [open, setOpen] = useState(false);
    const [discussionVal, setDiscussionVal] = useState("");
    const [callNoteDetailsArr, setCallNoteDetailsArr] = useState([]);

    // =============================

    const [detailsSection, setDetailsSection] = useState(true);
    const [attachmentSection, setAttachmentSection] = useState(false);
    const [fileName, setFileName] = useState("");
    const [selectedFile, setSelectedFile] = useState([]);
    const [selectedFileLimit, setSelectedFileLimit] = useState("")
    // const [preview, setPreview] = useState([]);
    const [saveLoading, setSaveLoading] = useState(false);
    const [discussionLoading, setDiscussionLoading] = useState(false);
    const [deleteIconVisiblity, setDeleteIconVisiblity] = useState({
        visibility: "hidden",
    });
    const [fillReport, setFillReport] = useState(false)

    const [showUserRating, setShowUserRating] = useState(0)

    const [phoneNumberFormat, setphoneNumberFormat] = useState();
    const [isRepairText, setIsRepairText] = useState(false)
    const [repairMsg, setRepairMsg] = useState("")
    const [estimateCost, setEstimateCost] = useState("")
    const [toolNeededText, setToolNeededText] = useState("")
    const [ticketId, setTicketId] = useState(0)
    const [dialogLoader, setDialogLoader] = useState(false);
    const [diagnosisReport, setDiagnosisReport] = useState({});

    const [callNotesToggle, setCallNotesToggle] = useState(true);

    // console.log(callDetailsObj)


    useEffect(() => {
        particularCallDetails();
        localStorage.setItem("triggerFlag", 1)
        return (() => {
            localStorage.setItem("triggerFlag", 0)

        })
    }, []);

    const particularCallDetails = () => {
        let details = {
            user_id_ids: localStorage.getItem("user_id"),
            call_log_id_ids: localStorage.getItem("call_log_id"),
            // call_log_id_ids: parseInt(callLogIdIds),
        };
        dispatch(
            callDetails(details, (e) => {
                setCallDetailsObj(e.data.data);
                localStorage.setItem("roomCode", e.data.data.room_id)

                setReceiverData(e.data.data.receiver_data);
                setTime(e.data.data.created_date_dtm + "000");
                setShowUserRating(e.data.data.user_rating.rating_value_int);
                setDiagnosisReport(e.data.data.diagnosis_report_details);
            })
        );
    };
    const resendLink = () => {
        setResendLoading(true);
        let resendDetails = {
            user_id_ids: localStorage.getItem("user_id"),
            call_log_id_ids: localStorage.getItem("call_log_id"),
        };
        dispatch(
            resendVideoLink(
                resendDetails,
                (e) => {
                    setShowSuccess(true);
                    particularCallDetails();
                    setTimeout(() => {
                        setShowSuccess(false);
                        setResendLoading(false);
                    }, 2500);
                },
                () => {
                    setShowError(true);
                    setShowError(true);
                    setTimeout(() => {
                        setShowError(false);
                        setResendLoading(false);
                    }, 2500);
                }
            )
        );
    };


    const deleteSingleDetails = (e) => {
        let details = {
            user_id_ids: localStorage.getItem("user_id"),
            user_call_log_id_ids:
                localStorage.getItem("user_call_log_id_ids")
            // userCallLogIdIds
            ,
        };
        dispatch(
            deleteCallHistory(details, (res) => {
                navigate("/callHistory");
            })
        );
    };

    const handleOpen = () => {
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
    };

    const detailsClicked = () => {
        setDetailsSection(true);
        setAttachmentSection(false);
    };
    const attachmentClicked = () => {
        setDetailsSection(false);
        setAttachmentSection(true);
    };

    const handleAttach = () => {
        hiddenFileInput.current.click();
    };

    const inputFileTarget = (e) => {


        const selectedFileLength = [...selectedFile];
        if (selectedFileLength.length < 10) {
            setDeleteIconVisiblity({ visibility: "visible" });
            setSelectedFile([...selectedFile, e.target.files[0]]);

            return;
        }
        return setSelectedFileLimit("*You can't add more than 10 files.")
    };

    const deleteUpload = (fileIndex) => {
        const updatedFile = selectedFile.filter((delElem, delElemIndex) => {
            return fileIndex !== delElemIndex;
        })
        setSelectedFile([...updatedFile]);
        setSelectedFileLimit("");

    };

    const discussionOnChange = (e) => {
        setDiscussionVal(e.target.value);
    };

    const handleSaveDiscussion = () => {
        setCallNotesToggle(true)
        setSaveLoading(true);
        let data = new FormData();

        data.append("user_id_ids", localStorage.getItem("user_id"));
        data.append("call_log_id_ids", localStorage.getItem("call_log_id"));
        data.append("call_note", discussionVal);
        selectedFile?.map((attachmentData, attachmentI) => {

            data.append(`attachment${attachmentI}`, attachmentData);
        })
        data.append("ticket_id_ids", localStorage.getItem("ticket_id"));
        // console.log(data,"particular ")
        dispatch(callNote(data, () => {
            setSelectedFile([]);
            setDiscussionVal("");
            setSaveLoading(false);
            callNoteData();
        }, (err) => {
            setSaveLoading(false);
        }))
    };

    const callNoteData = () => {
        setDiscussionLoading(true);
        let details = {
            user_id_ids: localStorage.getItem("user_id"),
            call_log_id_ids: localStorage.getItem("call_log_id"),
            // call_log_id_ids: callLogIdIds,
        };

        let data = new FormData();

        data.append("user_id_ids", localStorage.getItem("user_id"));
        data.append("call_log_id_ids", localStorage.getItem("call_log_id"));
        data.append("ticket_id_ids", localStorage.getItem("ticket_id"));


        dispatch(
            callNoteDetails(data, (res) => {
                setCallNoteDetailsArr(res.data.data);
                setDiscussionLoading(false);
            })
        );
    };

    useEffect(() => {
        callNoteData();
    }, []);


    const handleLayout = () => {
        localStorage.setItem("roomCode", callDetailsObj.room_id);

        navigate("/videoCall");
    };

    useEffect(() => {
        receiverData?.map((element) => {
            if (receiverData[0].phone_number == null || receiverData[0].phone_number == "") {
                setphoneNumberFormat("NA")
            } else {
                setphoneNumberFormat(InternationalPhoneFormatFun(`${receiverData[0].country_code}`, `${receiverData[0].phone_number}`))
            }
        })
    }, [receiverData])



    function handleRepairSuggestion(e) {
        setRepairMsg(e.target.value)
        setIsRepairText(false)
    }
    function handleToolNeded(e) {
        setToolNeededText(e.target.value)
    }

    function handleEstimateCost(e) {
        setEstimateCost(e.target.value.replace(/\D/g, ''))
    }

    function sendReport(e) {
        e.preventDefault();
        if (repairMsg.trim().length > 0) {
            setDialogLoader(true)
            const details = new FormData()
            details.append("call_log_id_ids", callDetailsObj.call_log_id_ids)
            details.append("generator_id_ids", localStorage.getItem("user_id"))
            details.append("generated_date_dtm", Date().toLocaleString())
            details.append("ticket_id_ids", callDetailsObj.ticket_detail.ticket_id_ids)
            details.append("ticket_creator_id_ids", callDetailsObj.ticket_detail.user_id_lng)
            details.append("professional_name_chr", localStorage.getItem("fullName"))
            details.append("product_type_chr", callDetailsObj.ticket_detail.product_type_chr)
            details.append("problem_description_chr", callDetailsObj.ticket_detail.problem_description_chr)
            details.append("repair_suggestions_chr", repairMsg.trim())
            details.append("tools_supplies_chr", toolNeededText.trim())
            details.append("estimated_cost_float", estimateCost.trim() === "" ? 0 : estimateCost.trim())
            dispatch(sendReportOfDiagonsisApi(details, (res) => {
                setDialogLoader(false)
                setRepairMsg("")
                setToolNeededText("")
                setEstimateCost("")
                setFillReport(false);
                handleCloseCallDetails();

                particularCallDetails();
            }, () => {
                setDialogLoader(false);

            }))
        } else {
            setIsRepairText(true)
        }
    }


    // Modal functions for the image preview
    const [openDoc, setOpenDoc] = React.useState(false);
    const [imageAttachURL, setImageAttachURL] = useState('');
    const handleOpenDoc = () => {
        setOpenDoc(true);
    }
    const handleCloseDoc = () => setOpenDoc(false);


    const backToPrevious = () => {
        navigate(-1)
    }

    // Modal triggers for the create diagnosis report

    const [showCallDetails, setShowCallDetails] = useState(false);

    const handleCloseCallDetails = (e) => {
        e?.preventDefault();
        setShowCallDetails(false);
        // ticketStatus(particularTicketID)
    };
    const handleShowCallDetails = (element) => {
        setShowCallDetails(true);
    }

    // Modal triggers for the Purchase List
    const [purchaseListTrigger, setPurchaseListTrigger] = useState(false);
    const handleClosePurchaseList = () => {
        setPurchaseListTrigger(false);
    };
    const handleShowPurchaseList = (e) => {
        setPurchaseListTrigger(true);
    }

    return (
        <>
            <div>
                <Card className='bg-white' style={{ marginBottom: '10px', height: 'auto' }}>
                    <Card.Header>
                        <Card.Title>
                            <h4 onClick={backToPrevious} className='back-to-admin-btn'>
                                <i style={{ marginRight: '10px', }} className="bi bi-arrow-left "></i>
                                {txtCallDetails}
                            </h4>
                        </Card.Title>
                    </Card.Header>
                    <Card.Body>
                        <div className='d-flex align-items-center call-details-btn-grp' >



                            {callDetailsObj.status_ysn === 1 &&

                                <WhiteGreenButton
                                    buttonName={btnJoinVideo}
                                    className={'green-background-btn'}
                                    variant={'primary'}
                                    onClick={() => { navigate("/videoCall") }}
                                />

                            }

                            {permissionArray.includes("SEND VIDEO LINK") &&
                                <WhiteGreenButton
                                    onClick={resendLink}
                                    buttonName={'Resend Link'}
                                    className={'white-background-btn'}
                                    variant={'primary'}
                                    loadingMessage={'Loading...'}
                                    isLoading={resendLoading}
                                />
                            }

                            {/* {(!resendLoading && (role !== 2)) &&
    <Button onClick={resendLink} className="white-background-btn" variant="primary">
        Resend Link
    </Button>
}
{resendLoading &&
    <Button disabled className="resent-btn" variant="primary">
        Loading...
    </Button>
} */}



                        </div>

                        <div className='callDetailsRows'>
                            <p className='call-titles' >{txtName}</p>
                            {receiverData?.map((element, index) => (
                                <p className='call-sub-titles'>{element?.name ? element?.name.split(' ')[0] : 'NA'}</p>
                            ))}
                        </div>

                        {/* <div className='callDetailsRows'>
<p className='call-titles' >{txtEmail}</p>
{receiverData.map((element, index) => (
    <p className='call-sub-titles' style={{ wordWrap: 'break-word' }}>{element.email ? element.email : 'NA'}</p>
))}
</div>

<div className='callDetailsRows'>
<p className='call-titles' >{txtPhoneNumber}</p>
{phoneNumberFormat != null && <p className='call-sub-titles'>{phoneNumberFormat}</p>}
</div> */}



                        <div className='callDetailsRows'>
                            <p className='call-titles'>{txtCreatedOn}</p>
                            <p className='call-sub-titles'>
                                {new Intl.DateTimeFormat("en-US", {
                                    year: "numeric",
                                    month: "long",
                                    day: "numeric",
                                    hour: "2-digit",
                                    minute: "2-digit",
                                    second: "2-digit",
                                }).format(time)}
                            </p>
                        </div>

                        <div className='callDetailsRows'>
                            <p className='call-titles'>{txtMessage}</p>
                            <p className='call-sub-titles'>{callDetailsObj?.message_chr ? callDetailsObj?.message_chr : 'NA'}</p>
                        </div>


                        <div className='callDetailsRows'>
                            <p className='call-titles'>Rating</p>
                            <ReadOnlyRating rating={showUserRating > 0 ? showUserRating : 0} />
                        </div>



                        <div className='d-flex align-items-center justify-content-end my-3 overflow-auto'>
                            {callNoteDetailsArr.length > 0 &&
                                <>
                                    {!callNotesToggle ?
                                        <OverlayTrigger placement="top" overlay={tooltipShowNotes}>
                                            <i onClick={() => setCallNotesToggle(true)} className="bi bi-eye-fill eye-btn"></i>
                                        </OverlayTrigger> :
                                        <OverlayTrigger placement="top" overlay={tooltipHideNotes}>
                                            <i onClick={() => setCallNotesToggle(false)} className="bi bi-eye-slash-fill eye-btn"></i>
                                        </OverlayTrigger>
                                    }
                                </>
                            }


                            {Object.keys(diagnosisReport).length !== 0 &&
                                <OverlayTrigger placement="top" overlay={tooltipDownload}>
                                    <a download href={process.env.REACT_APP_BASE_URL + `DocumentGenerator/GetPdf?call_log_id_ids=${callDetailsObj.call_log_id_ids}&ticket_id_ids=${callDetailsObj.ticket_id_ids}`}>
                                        <Button className="notification-btn attachment-btn" variant="primary" >
                                            <i style={{ fontSize: '21px' }} className="bi bi-file-earmark-arrow-down-fill"></i>
                                        </Button>
                                    </a>
                                </OverlayTrigger>
                            }

                            {permissionArray.includes("SEND VIDEO LINK") ?
                                <PrimaryButton
                                    // buttonName={ btnDiagnosisReport }
                                    buttonName={"Repair Diagnosis"}
                                    onClick={() => { handleShowCallDetails() }}
                                    style={{ width: '220px' }}
                                /> : null
                            }

                            <PrimaryButton
                                buttonName={"Purchase List"}
                                onClick={() => { handleShowPurchaseList() }}
                                style={{ marginLeft: '10px', width: '180px' }}
                            />
                        </div>




                        <TextArea
                            labelName={lblDiscussion}
                            placeholder={hintAddComments}
                            onChange={discussionOnChange}
                            value={discussionVal}
                            onBlur={() => { }}
                        />

                        <div style={{ color: 'red' }}>
                            <span>{selectedFileLimit}</span>
                        </div>

                        <div className='d-flex align-items-center' style={{ justifyContent: 'flex-end', }}>
                            <input
                                accept="image/*"
                                type="file"
                                multiple
                                style={{ display: "none" }}
                                ref={hiddenFileInput}
                                onChange={(e) => {
                                    inputFileTarget(e);
                                }}
                            />

                            <div className='attachment-img-preview-bar'>
                                {selectedFile?.map((previewFile, index) => {
                                    return (
                                        <span key={index} className='attachment-img-preview-span'>
                                            <i onClick={() => deleteUpload(index)} class="bi bi-x-circle attachment-img-preview-delete-icon"></i>
                                            <img
                                                style={{ width: '40px', height: '50px', borderRadius: '5px' }}
                                                src={previewFile ? URL.createObjectURL(previewFile) : null}
                                                alt='Error'
                                            />
                                        </span>
                                    )
                                })}
                            </div>


                            <OverlayTrigger placement="top" overlay={tooltipAttachment}>
                                <Button onClick={() => handleAttach()} className="notification-btn attachment-btn" variant="primary" >
                                    <i style={{ fontSize: '21px' }} className="bi bi-paperclip"></i>
                                </Button>
                            </OverlayTrigger>

                            {(selectedFile.length > 0 || discussionVal !== "") && !saveLoading &&
                                (<PrimaryButton
                                    buttonName={'Save'}
                                    onClick={() => { handleSaveDiscussion() }}
                                    loadingMessage={'Saving...'}
                                    isLoading={saveLoading}
                                    style={{ width: '100px' }}
                                />)
                            }

                            {saveLoading && <Spinner animation="border" size="sm" style={{ color: 'orange' }} />}

                        </div>

                        {discussionLoading &&
                            <div style={{ color: 'orange' }}>
                                Loading...
                            </div>
                        }
                        {/* height:callNoteDetailsArr.length == 1 ? '210px' : '280px' */}
                        {callNoteDetailsArr.length > 0 && callNotesToggle &&
                            <div className='call-notes-main-container'
                            // style={{ height: callNoteDetailsArr.length <= 1 ? '215px' : '280px', }}
                            >
                                <p className='call-notes-titles'>Call notes : </p>
                                <div className='call-notes-overflow-container'>
                                    {callNoteDetailsArr?.map((element, index) => (
                                        <div className='call-notes-sub-container'>
                                            <p className='call-notes-user-msg' >
                                                <span className='call-notes-user-icon' >
                                                    {element.created_by_name.substring(0, 1).toUpperCase()}
                                                </span>
                                                {element.note_chr}
                                            </p>

                                            <div className='call-notes-individual-img-attached-box'>
                                                <span className='d-flex align-items-center' style={{ justifyContent: 'flex-end', color: 'black' }}>
                                                    {new Intl.DateTimeFormat("en-US", {
                                                        year: "numeric",
                                                        month: "long",
                                                        day: "numeric",
                                                        hour: "2-digit",
                                                        minute: "2-digit",
                                                        second: "2-digit",
                                                    }).format(element.updated_date_dtm + "000")}
                                                </span>
                                                <div className='call-notes-individual-img-download-box' >
                                                    {element?.attachment_url.map((elem, ind) => {
                                                        return (
                                                            <span className='call-notes-individual-img-download-span' key={index}>
                                                                {/* <a
                                        href={elem?.note_attachments_url_chr}
                                        download
                                    > */}
                                                                <img
                                                                    className='call-notes-individual-img-download'
                                                                    src={elem}
                                                                    alt='Error'
                                                                    title='Download'
                                                                    onClick={() => {
                                                                        handleOpenDoc();
                                                                        setImageAttachURL(elem);
                                                                    }}
                                                                    style={{ cursor: 'pointer' }}
                                                                />
                                                                {/* </a> */}
                                                            </span>
                                                        )
                                                    })}
                                                </div>

                                            </div>
                                        </div>
                                    ))}


                                </div>

                            </div>
                        }
                    </Card.Body>
                </Card>
            </div>

            {/* Modal for the create diagnosis report */}
            <Modal className="fade" show={showCallDetails}
            // onHide={handleCloseCallDetails}
            >
                <Modal.Header style={{ borderBottom: 'none' }}>
                    <Modal.Title>
                        {`${btnDiagnosisReport}`}
                    </Modal.Title>
                    <Button
                        variant=""
                        className="call-btn-close btn-close"
                        // onClick={() => setBasicModal(false)}
                        onClick={() => handleCloseCallDetails()}
                    >

                    </Button>
                </Modal.Header>
                <Modal.Body>
                    <form onSubmit={(e) => (e)} style={{ padding: '5px' }}>
                        <p style={{ color: 'orange' }}>Please fill the following details , and add report for customer </p>

                        <div className='d-flex align-items-center'
                            style={{ justifyContent: 'space-between', fontSize: '14px', color: 'black', marginBottom: '10px' }}
                        >
                            <p className=' call-sub-titles'>{txtServiceID}</p>
                            <p className='call-titles'>{`#${callDetailsObj?.ticket_detail?.ticket_id_ids}`}</p>
                        </div>

                        <InputField
                            labelName={lblToolsSupplies}
                            placeholderName={hintToolsSupplies}
                            value={toolNeededText}
                            onChange={handleToolNeded}
                            onBlur={() => { }}
                        />

                        <InputField
                            labelName={lblEstimatedCostRepair}
                            placeholderName={hintEstimatedCostRepair}
                            value={estimateCost}
                            onChange={handleEstimateCost}
                            maxLength={8}
                            onBlur={() => { }}
                        />

                        <TextArea
                            labelName={lblRepairSuggestion}
                            placeholder={hintRepairSuggestion}
                            onChange={handleRepairSuggestion}
                            errorMessage={'Please add suggestion'}
                            value={repairMsg}
                            errorOccured={isRepairText}
                            onBlur={() => { }}
                        />



                        <div className='d-flex align-items-center' style={{ justifyContent: 'flex-end', }}>
                            <PrimaryButton
                                buttonName={'Cancel'}
                                onClick={(e) => { handleCloseCallDetails(e) }}
                                style={{ width: '110px' }}
                            />

                            <div style={{ marginLeft: '10px' }}>
                                <PrimaryButton
                                    buttonName={btnSubmit}
                                    onClick={(e) => { sendReport(e) }}
                                    loadingMessage={'Loading...'}
                                    isLoading={dialogLoader}
                                    style={{ width: '110px' }}
                                />
                            </div>

                        </div>
                    </form>
                </Modal.Body>
            </Modal>

            {/* Modal for previewing the attached image preview */}
            <>

                <Modal show={openDoc} onHide={handleCloseDoc} style={{ background: '#fff0', border: 'none', }}>

                    <div className='image-preview-modal-header'>

                        <a href={imageAttachURL} target="_blank" rel="noreferrer">
                            <i style={{ fontSize: '20px', marginLeft: '20px' }} className="bi bi-download image-preview-modal-action-btn" />
                        </a>

                        <div onClick={handleCloseDoc} className='image-preview-modal-action-btn-close'>
                            <i style={{ fontSize: '30px', }} className="bi bi-x"></i>
                        </div>

                    </div>

                    <>
                        <img src={imageAttachURL} alt='Error Loading' style={{ width: '100%', height: '100%' }} />
                    </>

                </Modal>
            </>

            {/* Purchase List modal */}
            {purchaseListTrigger &&
                <PurchaseList purchaseListTrigger={purchaseListTrigger} ticketDisplayName={callDetailsObj?.ticket_detail?.display_id_int} handleClosePurchaseList={handleClosePurchaseList} messageForPurchase={callDetailsObj?.ticket_detail?.problem_description_chr} categoryForPurchase={callDetailsObj?.ticket_detail?.category_name_chr} />
            }
        </>
    )
}

export default CallDetailsPage;